var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var ShareNetwork = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M13.9781 6.87188L8.52188 10.3781M8.52188 13.6219L13.9781 17.1281M9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM19.5 18.75C19.5 20.4069 18.1569 21.75 16.5 21.75C14.8431 21.75 13.5 20.4069 13.5 18.75C13.5 17.0931 14.8431 15.75 16.5 15.75C18.1569 15.75 19.5 17.0931 19.5 18.75ZM19.5 5.25C19.5 6.90685 18.1569 8.25 16.5 8.25C14.8431 8.25 13.5 6.90685 13.5 5.25C13.5 3.59315 14.8431 2.25 16.5 2.25C18.1569 2.25 19.5 3.59315 19.5 5.25Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
